module.exports = __webpack_public_path__ + "img/fw4.de177864.png";